import errorInvitationShareCoach from "@images/error/errorInvitationShareCoach.svg"
import { word } from "@modules/core/utils/i18n"
import { Text } from "@/components/ui/baseUi/text"

export function BoxStaffInvitationErrorView() {
  return (
    <div className="mx-12 mt-16 flex flex-col items-center justify-center rounded-4xl bg-neutral-100">
      <Text fontStyle="TM" className="mt-12 text-textDefault-heading">
        {word("box.staff.invitation.notValid.title")}
      </Text>
      <Text fontStyle="BM" className="mt-4 px-6 text-center text-textDefault-body">
        {word("box.staff.invitation.notValid.subtitle")}
      </Text>
      <div
        className="my-20 flex h-48 w-full bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${errorInvitationShareCoach})` }}
      ></div>
    </div>
  )
}
